module.exports = __webpack_public_path__ + "media/images/noimage-6201c96a.jpg";